define('facets_items_collection.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('facets_items_collection', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div data-type=\"backbone.collection.view.rows\"></div>  ";
},"useData":true}, 'extensions/Tavano/TT_Master_Theme_CapitolScientific/1.1.2/', 'extensions/Tavano/TT_Master_Theme_CapitolScientific/1.1.2/', Handlebars);
});